export default __webpack_public_path__ + "static/media/21-TangBiler.116e2abf.png";